import { readCookies as e } from "./cookies/cookie-parser-util.js";
import { GA_CLIENT_ID_COOKIE_NAME as t, parseGaClientIdCookie as n } from "./cookies/ga-client-id.js";
import { ErrorResponse as r, createErrorResponse as i } from "./errorResponse.js";
import { i as a, n as o, r as s, t as c } from "./chunks/repubs-BojZE0nv.js";
import { getUserGroup as l } from "./getUserGroup.js";
import { REPUBS as u } from "@cx-modules/constants";
import { REPUB_COUNTRY as d, SUPPORTED_REPUB_NAMES as f } from "@cx-web/domain-types";
//#region src/buildLinkedDataSchema.ts
function p(e) {
	if (e) return Array.isArray(e) ? {
		"@context": e[0]?.["@context"],
		"@graph": e.map((e) => {
			let { "@context": t, ...n } = e;
			return n;
		})
	} : e;
}
//#endregion
//#region src/repub-util.ts
function m(e) {
	return !!u[e];
}
//#endregion
//#region src/getPathExcludingRepubFromUrl.ts
function h(e, t) {
	if (!e) throw Error("repub is undefined");
	if (!m(e)) throw Error("repub not valid");
	let n = o(e), r = new URL(t), i = r.pathname;
	return n && i.startsWith(n) && (i = i.slice(n.length)), (i.startsWith("/") ? i.slice(1) : i) + r.search + r.hash;
}
//#endregion
//#region src/getPromiseResult.ts
var g = (e) => {
	if (e.status !== "rejected") return e.value;
}, _ = (e, t) => {
	let n = g(e);
	if (n == null) throw new Response(null, {
		status: 500,
		statusText: t
	});
	return n;
}, v = (e, t) => {
	if (e.status === "rejected") throw e.reason instanceof Response ? e.reason : new Response(null, {
		status: 500,
		statusText: t
	});
	if (e.value == null) throw new Response(null, {
		status: 500,
		statusText: t
	});
	return e.value;
};
//#endregion
//#region src/getRepubFromURL.ts
function y(e) {
	let t = e.pathname.split("/")[1]?.toUpperCase();
	return !m(t) || !u[t] ? u.OC.name : t;
}
//#endregion
//#region src/getSubeventId.ts
var b = (e) => /* @__PURE__ */ new Date() >= new Date(e.startTime) ? e.inPlaySubeventId : e.preMatchSubeventId, x = (e) => typeof e == "object" && !!e && "status" in e;
//#endregion
//#region src/myoc-base-path.ts
function S(e) {
	let t = e.toLowerCase();
	return t === "oc" ? "/myoddschecker" : `/${t}/myoddschecker`;
}
//#endregion
//#region src/repub-meta.ts
function C(e) {
	let t = Object.entries(u).reduce((t, [n, r]) => ({
		...t,
		[n]: e === r.name
	}), {}), n = e.toLowerCase(), r = f.some((e) => t[e]), i = r ? d[e] : "uk";
	return {
		repubIs: t,
		repubIsOCPlus: r,
		repubPath: o(e),
		repubHomeUrl: c(e),
		repubLowerCase: n,
		repubCountry: i
	};
}
function w(e) {
	let { repubIsOCPlus: t } = C(e);
	return t;
}
//#endregion
//#region src/updateI18nSingleton.ts
var T = /* @__PURE__ */ new WeakSet();
function E(e, t, n) {
	if (!T.has(e)) {
		e.init({
			lng: t,
			fallbackLng: "en-US",
			defaultNS: "label",
			resources: n,
			initImmediate: !1
		}), T.add(e);
		return;
	}
	e.language !== t && e.changeLanguage(t);
	for (let [t, r] of Object.entries(n)) if (r) for (let [n, i] of Object.entries(r)) e.addResourceBundle(t, n, i, !1, !0);
}
//#endregion
export { r as ErrorResponse, t as GA_CLIENT_ID_COOKIE_NAME, p as buildLinkedDataSchema, i as createErrorResponse, S as getMyOcBasePath, h as getPathExcludingRepubFromUrl, g as getPromiseResult, y as getRepubFromURL, c as getRepubHomeUrl, C as getRepubMetaFromRepub, o as getRepubPath, b as getSubeventId, l as getUserGroup, x as isErrorWithStatus, w as isOcPlusRepub, m as isValidRepub, n as parseGaClientIdCookie, e as readCookies, s as removeRepubPrefix, a as repubs, v as requireErrorAwarePromiseResult, _ as requirePromiseResult, E as updateI18nSingleton };
